module.exports = __webpack_public_path__ + "static/Amirah-a9803a84be0cf7a1efe43c17b8fe1f87.jpg";